







































































import Vue from 'vue';

export default Vue.extend({
  props: {
    fecha: String,
    disabled: Boolean,
  },
  data: () => ({
    openDialogImprimir: false,
    openDialog: false,
    egreso: '',
    mensaje: 'Imprimir Egreso',
    reportes: {
      gas: false,
      cE: false,
      varios: false,
      sF: false,
      date: '',
    },
  }),
  computed: {
  },
  methods: {
    async loadData() {
      console.log('FECHA DIALOG: %o', this.fecha);
      try {
        const admin = this.$store.getters.getAdmin;
        const condo = this.$store.getters.getCondo;
        this.reportes.fecha = this.fecha;
        const complementosDTO = this.reportes;
        console.log('reportes: ', complementosDTO);
        const result = await this.$store.dispatch('generarEgresos', {admin, condo, complementosDTO});
        this.egreso = result;
        // console.debug('generarRecibo result: %o', result);
        this.openDialog = false;
        this.openDialogImprimir = true;
      } catch (e) {
        this.$toast.error(e.response.data.message);
      }
    },
    printData() {
      this.$htmlToPaper('imprimirEgreso');
    },
  },
  watch: {
    openDialog() {
        // this.loadData();
    },
    // openDialogImprimir() {
    //     this.loadData();
    // },
  },
});
